import apiAxios from '@/services/axiosConfig';
import type { UpdateKeyRequest } from '@/types/api';

async function updateKey(uuid: string, data: UpdateKeyRequest): Promise<void> {
  await apiAxios.patch(`/api/v1/mt/connections/${uuid}`, data);
}

export default updateKey;
